import { BellOutlined } from '@ant-design/icons'
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom'
import { colspanMenu, colspanNotification, changeMenu } from 'store/actionReducers/MenuStore';
import ListNotifiCation from './ListNotifiCation';
import './HeaderTop.scss'
import { constUrlBase } from 'constants/api';

export default function HeaderTop() {
  const history = useHistory();
  const dispatch = useDispatch();
  const pathname = window.location.pathname;
  const MenuStore = useSelector((state: any) => state?.MenuStore);
  const menuActive = MenuStore?.menuActive?.urlActive

  useEffect(() => {
    dispatch(changeMenu({ urlActive: pathname }))
  }, [])

  const changePage = (url: string) => {
    if (url) {
      dispatch(colspanMenu())
      dispatch(changeMenu({ urlActive: url }))
      history.push(url);
    }
  }

  const handleShowMenu = () => {
    dispatch(colspanMenu())
  }

  const handleShowNotification = () => {
    dispatch(colspanNotification())
  }

  return (
    <>
      <div className='PJnMBVqBQF'>
        <div className={`zmzotuhyml ${MenuStore?.show ? 'CZKIIMOSEM' : ''}`}>
          <div className='zznnbymiwd'>
            <div onClick={() => changePage(`${constUrlBase.bang_gia.url}`)}
              className={`zezkifppkp ${menuActive === constUrlBase.bang_gia.url ? 'IvnerLlQYH' : ''}`} >Bảng giá</div>
            <div onClick={() => changePage(`${constUrlBase.phan_tich_thi_truong.url}`)}
              className={`zezkifppkp ${menuActive === constUrlBase.phan_tich_thi_truong.url || menuActive === '/' ? 'IvnerLlQYH' : ''}`} >Phân tích thị trường</div>
            <div onClick={() => changePage(`${constUrlBase.phan_tich_co_phieu.url}`)}
              className={`zezkifppkp ${menuActive === constUrlBase.phan_tich_co_phieu.url ? 'IvnerLlQYH' : ''}`} >Phân tích cổ phiếu</div>
            <div onClick={() => changePage(`${constUrlBase.danh_muc_dau_tu.url}`)}
              className={`zezkifppkp ${menuActive === constUrlBase.danh_muc_dau_tu.url ? 'IvnerLlQYH' : ''}`} >Danh mục đầu tư</div>
          </div>
          <div className='kvjoqxjcam'>
            <div className={`kcvkhcclue ydbnjqeezf ${MenuStore?.showNotification ? 'JMylYBRWxI' : ''}`}>
              <BellOutlined className='RsnLzyqrlY' onClick={() => handleShowNotification()} />
              <div className='nolmcspjfj'>
                <ListNotifiCation />
              </div>
            </div>
            <div className='zgbdmnjcsg'>Mở tài khoản</div>
            <div className='cnayfcoznh'>Đăng nhập</div>
          </div>
        </div>
        {MenuStore?.show ? <div className='BoygZhlcxu' onClick={() => handleShowMenu()}></div> : ''}
      </div>
    </>
  )
}